import { useMatches } from "react-router";
import { MutableRefObject, ReactNode } from "react";
import { Box, Breadcrumbs } from "@mui/material";
import theme from "../theme";

interface MatchHandle {
  crumb: (data: any) => ReactNode;
}

export const Breadcrumb = ({ portalRef }: { portalRef: MutableRefObject<HTMLElement | null> }) => {
  const matches = useMatches();
  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean((match.handle as MatchHandle)?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => (match.handle as MatchHandle).crumb(match.data));

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0, auto) 1fr",
        alignItems: "center",
      }}>
      <Breadcrumbs
        sx={{
          ".MuiBreadcrumbs-separator": {
            color: theme.palette.grey[200],
          },
          ol: {
            flexWrap: "nowrap",
            li: {
              flexShrink: 0,
              // this is the only we way we can target the lens name breadcrumb
              ":nth-of-type(3)": {
                minWidth: 0,
                flexShrink: 1,
              },
            },
          },
        }}>
        {crumbs}
      </Breadcrumbs>
      {/* \/ Breadcrumbs Right portal DO NOT REMOVE \/ */}
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flexGrow: 1 }} />
        <Box ref={portalRef} id="breadcrumbs-portal" />
      </Box>
    </Box>
  );
};
